angular.module('cfn').factory('cfnGridSelection', function() {
  var service = {};

  service.init = function(scope, element, attrs) {
    var serviceInstance = {};

    scope.selected = {};
    scope.selectionCount = 0;

    var updateSelectionCount = function() {
      var count = 0;
      $.each(scope.selected, function(k, v) {
        count++;
      });
      scope.selectionCount = count;
    };

    scope.updateSelectionView = function() {
      var all = true;
      var count = 0;

      var selected = [];
      $.each(scope.filterdData, function(idx, item) {
        count++;
        if (!item.$cfngrid_selected) {
          all = false;
        } else {
          selected.push(item);
        }
      });
      scope.allSelected = all && count > 0;
      if (!scope.infoObject) scope.infoObject = {};
      scope.infoObject.selected = selected;
      updateSelectionCount();
    };

    scope.clearSelection = function() {
      $.each(scope.selected, function(k, v) {
        if (v) v.$cfngrid_selected = false;
      });
      scope.selected = {};
      scope.allSelected = false;
      updateSelectionCount();
    };

    scope.setSelectedRowByObj = function(obj) {
      console.log(scope);
      scope.clearSelection();
      select(obj);
      updateSelectionCount();
    };

    // bring an item into view, select it
    scope.selectInViewById = function(id) {
      function after(item) {
        if (scope.multiselection === 'false' || !scope.multiselection) {
          scope.clearSelection();
          select(item);
        } else {
          if (!item.$cfngrid_selected) {
            select(item);
          } else {
            item.$cfngrid_selected = false;
            if (scope.selected[item.id]) {
              delete scope.selected[item.id];
            }
          }
        }

        updateSelectionCount();
      }

      var ds = scope.datasource();

      if (ds) {
        if (scope.viewDataHash[id]) {
          after(scope.viewDataHash[id]);
        } else {
          ds.getViewDataById(id, function(result) {
            //todo: bring into view!
            after(result.ob);
          });
        }
      } else {
        var result = null;
        //TOOD: model hash? - actually probably not needed
        $.each(scope.ngModel, function(k, v) {
          if (v.id == id) result = v;
        });

        if (result) after(result);
      }
      if (scope.selectionchange()) scope.selectionchange()(scope.selected);
    };

    scope.scrollSelectionIntoView = function() {
      element.find('.selected').scrollintoview({ onlyInvisible: true });
    };

    scope.itemSelectionChanged = function(item) {
      if (item.$cfngrid_selected) {
        scope.selected[item.id] = item;
      } else {
        if (scope.selected[item.id]) {
          delete scope.selected[item.id];
        }
      }

      if (scope.multiselection)
        // need to update sort !
        scope.updateView(scope.datasource());

      if (scope.selectionchange()) scope.selectionchange()(scope.selected);

      updateSelectionCount();
    };

    function select(item) {
      item.$cfngrid_selected = true;
      scope.selected[item.id] = item;
    }

    serviceInstance.updateOrderBySelection = function(sortedModel) {
      if (
        scope.multiselection === 'true' &&
        scope.moveSelectedToTop === 'true'
      ) {
        // first selected, then the rest
        var curSortedModel = sortedModel;
        var sel = [];
        sortedModel = [];
        for (i = 0; i < curSortedModel.length; i++) {
          var modelRow = curSortedModel[i];
          if (modelRow.$cfngrid_selected) {
            sortedModel.push(modelRow);
            sel.push(modelRow);
          }
        }
        // console.debug("sel",sel);
        for (i = 0; i < curSortedModel.length; i++) {
          var modelRow = curSortedModel[i];
          if (!modelRow.$cfngrid_selected) sortedModel.push(modelRow);
        }
      }
      return sortedModel;
    };

    return serviceInstance;
  };

  return service;
});
